import { Card } from "./ui/card";

export function PageContainer({ children }: { children: React.ReactNode }) {
  return (
    <Card className="w-full max-w-4xl mx-auto p-6 bg-white/90 backdrop-blur-sm shadow-lg">
      {children}
    </Card>
  );
}